
import { AfpUserContact } from "@/models/AfpUser";
import Swal from "sweetalert2";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class ContactComponent extends Vue{
	@Prop() contact: AfpUserContact;
	@Prop() index: number;

	public expand: boolean = false;

	public mounted(){
		this.expand = this.contact.isExpanded;
	}
	public expandContact(){
		this.expand = !this.expand;
	}

	public isSelected(value){
		if (this.contact == null)
			return false;
		if(this.contact.parentescocontacto == value)
			return true
	}
}

